export const note = {
  Note: "Note",
  NewNote: "New Note",
  NewNoteDesc: "Start a new note",
  NewNoteSuccess: "New note created.",
  DeleteNote: "Delete Note",
  DeleteNoteDesc: "Delete the note",
  DeleteNoteSuccess: "Note deleted successfully.",
  Project: "Project",
  SelectProject: "Select Project",
  SelectProjectDesc: "Select a project to use a note.",
} as const;
